import { ReviewStatisticsOverTimeBreakdownModel } from '../../../models/review-statistics-over-time-breakdown.model';
import { OvertimeChartModel } from '../models/overtime-chart.model';
import { monthNamesShort } from './month-names-short.constant';

const mapDateStringToMonthName = (dateStr: string) => {
  const date = new Date(dateStr);
  return monthNamesShort[date.getMonth()];
};

export const mapStatsRatingDataToOvertimeChartModel = (
  x: ReviewStatisticsOverTimeBreakdownModel
): OvertimeChartModel => ({
  rating: x.totalRating,
  month: mapDateStringToMonthName(x.momentInTime),
});
